import { PharosApiUnknownError } from '../apis/rpm.js';
import getStore from '../store/index.js';
import { actions as errorActions } from '../store/state/error.js';

export default function globalErrorHandler(error) {
  const store = getStore();
  store.dispatch(errorActions.REPORT(getErrorMessage(error)));
  console.error(error);
}

function getErrorMessage(error) {
  if (error instanceof PharosApiUnknownError) {
    return 'Network error';
  } else {
    return error.message;
  }
}
